const url = '/service-abbreviations';
const Provider = 'ServiceAbbreviations';
const dbModel = 'ServiceAbbreviations';

export { url, Provider, dbModel };
